var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditTopic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9878 1.00018C27.6522 1.00543 27.332 1.14175 27.0955 1.37982L1.37023 27.0912C1.13095 27.3339 0.997801 27.6616 1.00003 28.0024V35.7187C1.00123 36.0581 1.13663 36.3833 1.3767 36.6233C1.61677 36.8633 1.94203 36.9988 2.28154 37H9.99911C10.3399 37.0022 10.6677 36.869 10.9104 36.6297L36.6261 10.9088C36.8656 10.6678 37 10.342 37 10.0023C37 9.6627 36.8656 9.33686 36.6261 9.09595L28.9086 1.37967C28.788 1.25838 28.6445 1.16233 28.4864 1.09716C28.3283 1.032 28.1588 0.999049 27.9878 1.00018Z",
    stroke: "#193243",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTopic);
export default __webpack_public_path__ + "static/media/editTopic.395e2d61f0aa1e96267c77957a31a575.svg";
export { ForwardRef as ReactComponent };